import { KPI_W, KPI_S, KPH_W, KPH_S } from '../../OverworldAnimation.js';

export default class VerticalOptionsMenu {
    constructor({ options = [], initialOption = 0, initialDelay = 30, repeatRate = 10 }) {
        this.options = options;
        this.currentOption = initialOption;

        // Hold timing for vertical navigation
        this.verticalHoldFrames = 0;
        this.verticalInitialDelay = initialDelay; // Frames before repeating
        this.verticalRepeatRate = repeatRate; // Change every N frames after initial delay

        // Track which direction is being held
        this.currentVerticalDirection = null; // 'up' or 'down'
        this.isActive = false;
    }

    increaseVerticalOption() {
        console.log('increaseVerticalOption', this.currentOption);
        const maxOptions = this.options.length;
        if (maxOptions === 0) return;
        this.currentOption = (this.currentOption + 1) % maxOptions;
    }

    decreaseVerticalOption() {
        const maxOptions = this.options.length;
        if (maxOptions === 0) return;
        this.currentOption = (this.currentOption - 1 + maxOptions) % maxOptions;
    }

    handleVerticalInput() {
        let moved = false;

        // Handle UP input
        if (KPI_W) {
            console.log('up');
            // Initial press
            this.decreaseVerticalOption();
            this.currentVerticalDirection = 'up';
            this.verticalHoldFrames = 0;
            moved = true;
        } else if (KPH_W) {
            // Holding UP
            if (this.currentVerticalDirection === 'up') {
                this.verticalHoldFrames++;

                // After initial delay, start repeating
                if (this.verticalHoldFrames >= this.verticalInitialDelay) {
                    const framesAfterDelay = this.verticalHoldFrames - this.verticalInitialDelay;
                    if (framesAfterDelay % this.verticalRepeatRate === 0) {
                        this.decreaseVerticalOption();
                        moved = true;
                    }
                }
            }
        }

        // Handle DOWN input
        if (KPI_S) {
            console.log('down');
            // Initial press
            this.increaseVerticalOption();
            this.currentVerticalDirection = 'down';
            this.verticalHoldFrames = 0;
            moved = true;
        } else if (KPH_S) {
            // Holding DOWN
            if (this.currentVerticalDirection === 'down') {
                this.verticalHoldFrames++;

                // After initial delay, start repeating
                if (this.verticalHoldFrames >= this.verticalInitialDelay) {
                    const framesAfterDelay = this.verticalHoldFrames - this.verticalInitialDelay;
                    if (framesAfterDelay % this.verticalRepeatRate === 0) {
                        this.increaseVerticalOption();
                        moved = true;
                    }
                }
            }
        }

        // Reset if neither vertical key is held
        if (!KPH_W && !KPH_S && !KPI_W && !KPI_S) {
            this.currentVerticalDirection = null;
            this.verticalHoldFrames = 0;
        }

        return moved;
    }

    // Utility methods
    getCurrentOption() {
        return this.currentOption;
    }

    getCurrentOptionValue() {
        return this.options[this.currentOption];
    }

    setOptions(newOptions) {
        this.options = newOptions;
        // Ensure currentOption is still valid
        if (this.currentOption >= this.options.length) {
            this.currentOption = Math.max(0, this.options.length - 1);
        }
    }

    setCurrentOption(index) {
        if (index >= 0 && index < this.options.length) {
            this.currentOption = index;
        }
    }

    getOptionsCount() {
        return this.options.length;
    }

    reset() {
        this.currentOption = 0;
        this.verticalHoldFrames = 0;
        this.currentVerticalDirection = null;
    }
}
